// Capability code constants.
//
// SOURCE OF TRUTH: backend_go/internal/authz/capabilities.go (`Cap*` consts /
// `Registry()`). Keys here are SCREAMING_SNAKE mirrors of the Go const names;
// values MUST exactly equal the Go string codes. If the Go registry changes,
// update this file to match — do not let the two drift.
export const CAPS = {
  FINANCE_VIEW_SUMMARY: "finance.view_summary",
  FINANCE_VIEW_DRIVERS: "finance.view_drivers",
  FINANCE_VIEW_SENSITIVE: "finance.view_sensitive",
  INVESTIGATION_VIEW: "investigation.view",
  INVESTIGATION_CREATE: "investigation.create",
  INVESTIGATION_EXPLAIN: "investigation.add_explanation",
  INVESTIGATION_ACK: "investigation.acknowledge",
  BUDGET_PREPARE: "budget.prepare",
  BUDGET_SUBMIT: "budget.submit",
  BUDGET_MANAGE_INPUTS: "budget.manage_inputs",
  BUDGET_APPROVE: "budget.approve",
  CONFIG_DIMENSIONS: "config.dimensions",
  CONFIG_ALLOC_MODELS: "config.allocation_models",
  CONFIG_ALLOC_PROPOSE: "config.allocation_propose",
  CONFIG_BUDGET_POLICIES: "config.budget_policies",
  CONFIG_REPORTING: "config.reporting",
  PERIOD_LOCK: "period.lock",
  INTEGRATIONS_MANAGE: "integrations.manage",
  INVOICES_REVIEW: "invoices.review",
  REPORTS_BOARD_MANAGE: "reports.board.manage",
  SECRETS_MANAGE: "secrets.manage",
  USERS_MANAGE: "users.manage",
  ROLES_ASSIGN: "roles.assign",
  SSO_CONFIGURE: "sso.configure",
  ACCESS_REVIEW: "access.review",
  TENANT_CONFIGURE: "tenant.configure",
  TENANT_EMERGENCY: "tenant.emergency_access",
  AUDIT_VIEW: "audit.view",
  AUDIT_EXPORT: "audit.export",
  SERVICE_ACCOUNTS_MANAGE: "service_accounts.manage",
} as const;

export type CapabilityCode = (typeof CAPS)[keyof typeof CAPS];
